import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import StudentInfo from "./StudentInfo";
import late from "../../assets/images/late_fee_img.jpg";
import Bill_1 from "../../assets/images/Bill_1.png";

/**
 * Same layout as PrintChallan, but loads data from tblChalanHead + tblADLedger
 * via ChallanFeeSystem/PrintChallansFromHead (max 50 challans per API call; id lists are chunked).
 *
 * URLs:
 * - /students/PrintChalanHead/?ChalanHeadIds=1,2,3
 * - /students/PrintChalanHead/?bySearchPage=1  (payload in sessionStorage key challanPrintUseSearchPage)
 */
function PrintChallanFromHead() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(false);
  const [voucheres, setVouchers] = useState([]);
  const [SchoolName, setSchoolName] = useState("");
  const [Site, setSite] = useState("");
  const [bank, setBank] = useState("");
  const [defaultDueDate, setDefaultDueDate] = useState("");

  useEffect(() => {
    let cancelled = false;
    document.title = "Print Challan (generated)";
    setLoading(true);

    const apiUrl = config.base_url + "ChallanFeeSystem/PrintChallansFromHead";
    const axiosOpts = {
      headers: { "Content-Type": "application/json" },
      timeout: 120000,
    };

    const applyMeta = (data) => {
      if (!data || data.status_code !== 1) return;
      setSchoolName(data.SchoolName || "");
      setBank(data.FeeVoucherStatement || "");
      setSite(data.Website || "");
      setDefaultDueDate(data.DueDate || "");
    };

    (async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const bySearchPage = urlParams.get("bySearchPage") === "1";

        if (bySearchPage) {
          const raw = sessionStorage.getItem("challanPrintUseSearchPage");
          if (!raw) {
            return;
          }
          let payload;
          try {
            payload = JSON.parse(raw);
          } catch {
            return;
          }
          const response = await axios.post(apiUrl, payload, axiosOpts);
          if (cancelled) return;
          applyMeta(response.data);
          if (response.data.status_code === 1) {
            setVouchers(response.data.ListofRecords || []);
          }
          return;
        }

        const chalanHeadIds =
          urlParams.get("ChalanHeadIds") || urlParams.get("ids") || "";
        const parts = chalanHeadIds
          .split(/[,;]/)
          .map((s) => s.trim())
          .filter(Boolean);

        if (parts.length === 0) {
          return;
        }

        const base = {
          AccessKey,
          UserID: parseInt(UserID, 10) || 0,
          MemberType,
          PrintChallanUseSearchPage: false,
          ChalanHeadIds: "",
        };

        const chunkSize = 50;
        let merged = [];
        for (let i = 0; i < parts.length; i += chunkSize) {
          const chunk = parts.slice(i, i + chunkSize);
          const response = await axios.post(
            apiUrl,
            { ...base, ChalanHeadIds: chunk.join(",") },
            axiosOpts
          );
          if (cancelled) return;
          if (response.data.status_code === 1) {
            applyMeta(response.data);
            merged = merged.concat(response.data.ListofRecords || []);
          }
        }
        if (!cancelled) setVouchers(merged);
      } catch {
        /* network / timeout */
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [AccessKey, UserID, MemberType]);

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spinner animation="border" role="status"></Spinner>
      </div>
    );
  }

  if (!voucheres.length) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        No challans to print. Check challan ids or permissions.
      </div>
    );
  }

  return voucheres.map((item, index) => {
    const fee = item.ReducedLedger || [];
    const rowDue = item.DueDate || defaultDueDate;
    const statusType = item.Status_Type_Id != null ? item.Status_Type_Id : 0;

    return (
      <React.Fragment key={item.ChalanHead_ID || index}>
        <div
          style={{
            backgroundColor: "#FFF",
            color: "#000",
            width: "100%",
            fontSize: "11px",
          }}
          align="right"
        >
          <div
            className={index === voucheres.length - 1 ? "" : "page-break-after"}
            style={{
              width: "1140px",
              height: "730px",
              lineHeight: "18px",
            }}
          >
            <table style={{ width: "1140px" }} cellSpacing={0} cellPadding={0}>
              <tbody>
                <tr>
                  <td
                    style={{ width: "340px", paddingRight: "30px" }}
                    valign="top"
                    align="left"
                  >
                    <div>
                      <StudentInfo
                        school={SchoolName}
                        studentcode={
                          !item.Registration_No || item.Registration_No === ""
                            ? item.Student_ID + " (New Registration)"
                            : item.Registration_No
                        }
                        studentID={item.Student_ID}
                        classname={item.Class_Name}
                        section={item.Section_Name}
                        name={item.Student_Name}
                        wing={item.Wing_Name}
                        father={item.Father_Name}
                        bank={bank}
                        copy="Bank Copy"
                        DueDate={rowDue}
                        fee={fee}
                        status_type={statusType}
                        challanNoDisplay={item.Challan_No}
                        monthPeriodDisplay={item.Challan_Month_Label}
                      />
                      <div style={{ padding: "10px 0px 16px 0px" }}>
                        <table
                          style={{ width: "100%" }}
                          cellSpacing={0}
                          cellPadding={0}
                        >
                          <tbody>
                            <tr>
                              <td>NOT TO BE DEPOSITED AFTER DUE DATE</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "340px" }} valign="middle" align="center">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        gap: "6px",
                        border: "1px solid",
                        borderRadius: "10px",
                        padding: "10px",
                      }}
                    >
                      <img src={Bill_1} width={150} alt="jazz cash" />
                      <b style={{ margin: "0", fontSize: "12px" }}>
                        Pay Fee from any mobile app using 1 bill Invoice / Voucher option
                      </b>
                      <p style={{ margin: "0", fontSize: "11px" }}>
                        Transaction charges shall apply Use the Prefix 267200388
                        followed by Challan #
                      </p>

                       {/* <p style={{ margin: 0, direction: "rtl" }}>
                                            <strong className='font-ur' style={{ fontSize: "9px", paddingTop: "3px" }}>
                                                والدین سے گزارش ہے کہ ماہ جولائی اور اگست کا فیس چالان ہرمہینے کی پانچ تاریخ سے آفس سے وصول کر لیں یا ویب سائٹ سے پرنٹ نکال لیں اور شیڈول کے مطابق فیس بروقت جمع کروائیں۔ مسلسل دو ماہ فیس ادا نہ کرنے کی صورت میں 500روپے ری ایڈمیشن ادا کرنا پڑے گا۔
                                            </strong>
                                        </p> */}

                    </div>
                  </td>
                  <td
                    style={{ width: "340px", paddingLeft: "30px" }}
                    valign="top"
                    align="left"
                  >
                    <div>
                      <div>
                        <StudentInfo
                          school={SchoolName}
                          studentcode={
                            !item.Registration_No || item.Registration_No === ""
                              ? item.Student_ID + " (New Registration)"
                              : item.Registration_No
                          }
                          studentID={item.Student_ID}
                          classname={item.Class_Name}
                          section={item.Section_Name}
                          name={item.Student_Name}
                          wing={item.Wing_Name}
                          father={item.Father_Name}
                          bank={bank}
                          DueDate={rowDue}
                          showphoto={true}
                          copy="Student Copy"
                          fee={fee}
                          status_type={statusType}
                          challanNoDisplay={item.Challan_No}
                          monthPeriodDisplay={item.Challan_Month_Label}
                        />
                        <div style={{ padding: "10px 0px 16px 0px" }}>
                          <table
                            style={{ width: "100%" }}
                            cellSpacing={0}
                            cellPadding={0}
                          >
                            <tbody>
                              <tr>
                                <td>NOT TO BE DEPOSITED AFTER DUE DATE</td>
                              </tr>
                            </tbody>
                          </table>
                          <table
                            style={{
                              width: "100%",
                              border: "1px solid #000000",
                            }}
                            cellSpacing={2}
                            cellPadding={2}
                          >
                            <tbody>
                              <tr>
                                <td colSpan={2} align="left">
                                  For Online Services visit <strong>{Site}</strong>
                                </td>
                              </tr>
                              <tr>
                                <td>Login :{item.Registration_No}</td>
                                <td>Password :{item.Password}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div>
                          {fee.map((val) =>
                            val.Fee_Code === "033" ? (
                              <img
                                style={{ width: "100%" }}
                                src={late}
                                alt="late fee"
                              />
                            ) : (
                              ""
                            )
                          )}
                        </div>
                        <div style={{ padding: "0px" }}>
                          <table
                            style={{ width: "100%" }}
                            cellSpacing={0}
                            cellPadding={0}
                          >
                            <tbody>
                              <tr>
                                <td align="left">Officer</td>
                                <td align="right">Cashier</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </React.Fragment>
    );
  });
}

export default PrintChallanFromHead;
